import React from 'react';

import {
  HomeOutlined,
  CrownOutlined,
  AlignLeftOutlined,
  FontColorsOutlined,
  TeamOutlined,
  ReadOutlined,
  SettingOutlined,
  IssuesCloseOutlined,
  SolutionOutlined,
  RadarChartOutlined,
  BankOutlined,
  MessageOutlined,
  DollarCircleOutlined,
  OrderedListOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { ROUTES } from 'config/routes';
import {
  ADMIN_LIST,
  DICTIONARY_LIST,
  LOCALIZATION_LIST,
  NEWS_LIST,
  ROLE_LIST,
  SETTINGS_LIST,
  USER_LIST,
  COMPLAINTS_LIST,
  KEYWORDS_LIST,
  KEYWORDS_VIOLATIONS_LIST,
  FAKE_USER_LIST,
  RADAR_LIST,
  GIFT_VIEW,
  GIFT_CATEGORY_VIEW,
  MARKET_LIST,
  COIN_PACKET_VIEW,
  JJFORTUNE_VIEW,
} from 'config/roles';

const options = [
  {
    path: ROUTES.HOME_PAGE,
    nameId: 'sidebar.dashboard',
    icon: <HomeOutlined />,
  },
  {
    path: ROUTES.ADMINISTRATION,
    nameId: 'sidebar.administration',
    icon: <CrownOutlined />,
    permissions: [ADMIN_LIST, ROLE_LIST],
  },
  {
    path: ROUTES.NEWS,
    nameId: 'sidebar.news',
    icon: <AlignLeftOutlined />,
    permissions: NEWS_LIST,
  },
  {
    permissions: [KEYWORDS_VIOLATIONS_LIST, KEYWORDS_LIST, COMPLAINTS_LIST],
    nameId: 'sidebar.moderation',
    icon: <IssuesCloseOutlined />,
    subMenu: [
      {
        permissions: [KEYWORDS_VIOLATIONS_LIST, KEYWORDS_LIST],
        path: ROUTES.KEYWORDS_VIOLATIONS,
        nameId: 'sidebar.violations'
      },
      {
        permissions: [COMPLAINTS_LIST],
        path: ROUTES.COMPLAINTS,
        nameId: 'sidebar.complaints',
      },
    ]
  },
  {
    path: ROUTES.LANGUAGES,
    permissions: LOCALIZATION_LIST,
    nameId: 'sidebar.languages',
    icon: <FontColorsOutlined />,
  },
  {
    path: ROUTES.USERS,
    permissions: USER_LIST,
    nameId: 'sidebar.users',
    icon: <TeamOutlined />,
  },
  {
    path: ROUTES.AUTHORS,
    permissions: USER_LIST,
    nameId: 'sidebar.authors',
    icon: <SolutionOutlined />,
    devOnly: true,
  },
  {
    path: ROUTES.PAYOUTS,
    permissions: USER_LIST,
    nameId: 'sidebar.payouts',
    icon: <WalletOutlined />,
    devOnly: true,
  },
  {
    nameId: 'sidebar.dictionaries',
    permissions: DICTIONARY_LIST,
    icon: <ReadOutlined />,
    subMenu: [
      {
        path: ROUTES.BUSINESS_LINES,
        nameId: 'sidebar.business_lines',
      },
      {
        path: ROUTES.INTERESTS,
        nameId: 'sidebar.interests',
      },
      {
        path: ROUTES.LANGUAGES_SPOKEN,
        nameId: 'sidebar.languages_spoken',
      },
      {
        path: ROUTES.LOCATIONS,
        nameId: 'sidebar.locations',
      },
    ],
  },
  {
    nameId: 'sidebar.services',
    icon: <BankOutlined />,
    subMenu: [
      {
        permissions: [GIFT_VIEW, GIFT_CATEGORY_VIEW],
        path: ROUTES.GIFTS,
        nameId: 'sidebar.gifts'
      },
      {
        permissions: [MARKET_LIST],
        path: ROUTES.PACKAGES,
        nameId: 'sidebar.packages',
      },
      {
        permissions: [MARKET_LIST],
        path: ROUTES.PAID_SERVICES,
        nameId: 'sidebar.paid_services'
      },
      {
        permissions: [COIN_PACKET_VIEW],
        path: ROUTES.JJ_COINS,
        nameId: 'sidebar.jj_coins',
        hidden: true,
      },
      {
        permissions: [COIN_PACKET_VIEW],
        path: ROUTES.JJ_LIKES_PACKAGES,
        nameId: 'sidebar.jj_likes_packages',
      },
    ]
  },
  {
    nameId: 'sidebar.incomes',
    permissions: [JJFORTUNE_VIEW],
    icon: <DollarCircleOutlined />,
    subMenu: [
      {
        nameId: 'sidebar.jj_fortune',
        path: ROUTES.JJ_FORTUNE,
      },
      {
        nameId: 'sidebar.jj_likes',
        path: ROUTES.JJ_LIKES,
      },
      {
        nameId: 'sidebar.jj_premium',
        path: ROUTES.JJ_PREMIUM,
      },
      {
        nameId: 'sidebar.jj_fun',
        path: ROUTES.JJ_FUN,
      },
      {
        nameId: 'sidebar.jj_video',
        path: ROUTES.JJ_VIDEO,
      },
      {
        nameId: 'sidebar.statistics',
        path: ROUTES.STATISTICS,
      },
      {
        nameId: 'sidebar.add_jj_coins',
        path: ROUTES.ACCRUAL_COINS,
      }
    ]
  },
  {
    path: ROUTES.JJ_INCOME,
    permissions: [JJFORTUNE_VIEW],
    nameId: 'sidebar.jj_income',
    icon: <DollarCircleOutlined />,
  },
  {
    path: ROUTES.CONTENT,
    permissions: FAKE_USER_LIST,
    nameId: 'sidebar.content',
    icon: <SolutionOutlined />,
  },
  {
    path: ROUTES.RADAR,
    permissions: RADAR_LIST,
    nameId: 'sidebar.radar',
    icon: <RadarChartOutlined />,
  },
  {
    path: ROUTES.CHATS,
    nameId: 'sidebar.chats',
    icon: <MessageOutlined />,
  },
  {
    path: ROUTES.AGREEMENTS,
    nameId: 'sidebar.agreements',
    icon: <OrderedListOutlined />,
  },
  {
    path: ROUTES.SETTINGS,
    permissions: SETTINGS_LIST,
    nameId: 'sidebar.settings',
    icon: <SettingOutlined />,
  },
];

export default options;
